import React from 'react';
import PropTypes from 'prop-types';

import { IComponent } from '../../../typings/generic-component';
import { makeClassNames, IClassNames } from '../../../utils/styles';
import './data-center-skeleton.scss';
import Card from '../card/card';
import Skeleton from '../../atoms/skeleton/skeleton';
import { COLOR_SCHEMA_DARK, COMPONENT_SIZE_RESPONSIVE } from '../../../typings/design-tokens';

export interface IDataCenterSkeleton extends IComponent {
  rowCount: number;
}

const classNames = (): IClassNames =>
  makeClassNames({
    DataCenterSkeleton: 'data-center-skeleton',
    DataCenterSkeletonTitle: 'data-center-skeleton__title',
    DataCenterSkeletonContent: 'data-center-skeleton__content',
    DataCenterSkeletonContentEl: 'data-center-skeleton__content-element',
    DataCenterSkeletonCTA: 'data-center-skeleton__cta',
  });

const DataCenterSkeleton: React.FC<IDataCenterSkeleton> = ({
  /* istanbul ignore next: default value */ colorSchema = COLOR_SCHEMA_DARK,
  /* istanbul ignore next: default value */ size = COMPONENT_SIZE_RESPONSIVE,
  rowCount,
}) => {
  const cn = classNames();
  return (
    <div className={cn.DataCenterSkeleton}>
      <Card colorSchema={colorSchema} size={size}>
        <Skeleton className={cn.DataCenterSkeletonTitle} isText fontSize="22" width="150px" colorSchema={colorSchema} />

        <div className={cn.DataCenterSkeletonContent}>
          {[...Array(rowCount + 1).keys()].map((key) => (
            <div key={key} className={cn.DataCenterSkeletonContentEl}>
              <Skeleton colorSchema={colorSchema} isText fontSize="14" />
            </div>
          ))}
        </div>

        <div className={cn.DataCenterSkeletonCTA}>
          <Skeleton height={['56px', '18px', '18px']} width={['100%', '110px', '110px']} colorSchema={colorSchema} />
        </div>
      </Card>
    </div>
  );
};

/* istanbul ignore else */ if (process.env.NODE_ENV !== 'production') {
  DataCenterSkeleton.propTypes = {
    rowCount: PropTypes.number.isRequired,
  };
}

export default DataCenterSkeleton;
